<script lang="ts">
    import Markdown from "./Markdown.svelte"

    let { block }: { block: BlackTextBlock } = $props()
</script>

<div class="black-text-box">
    <Markdown text={block.content.text} />
</div>

<style lang="less" global>
    div.black-text-box {
        color: var(--bright-100);
        display: flex;
        padding: 2.4rem;
        justify-content: center;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.5rem;
        border-radius: 4px;
        background: var(--bg-400);
        max-width: 100%;
        width: 100%;
        strong {
            color: var(--bright-100) !important;
        }
    }
</style>
